import { QuoteApiModel } from '~/lib/api/smartsend/types';

export const isDeliveryToShopQuote = (quote: QuoteApiModel): boolean => {
  return (
    (quote.Service.DeliveryType === 'Shop' || quote.Service.DeliveryType === 'Locker') &&
    !!quote.Service.PickUpProviderCode
  );
};
